import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProgressBarService } from 'app/services/progress-bar/progress-bar.service';
import { ProgressBarMode } from '@angular/material/progress-bar';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
    value: number;
    mode: ProgressBarMode;
    needed: boolean;
    private subscriptions = new Subscription();

    constructor(private progressBarService: ProgressBarService) { }

    ngOnInit(): void {
        this.subscriptions.add(this.progressBarService.value.subscribe(value => this.value = value));
        this.subscriptions.add(this.progressBarService.mode.subscribe(mode => this.mode = mode));
        this.subscriptions.add(this.progressBarService.needed.subscribe(needed => this.needed = needed));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
